module.exports = __webpack_public_path__ + "static/img/6273_phase_function_Paper_PointsHejduk_Prediction.5d0d0ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6273_phase_function_Paper_PointsHejduk_Prediction.png
// module id = LH0X
// module chunks = 0